import { Box, Typography, CircularProgress } from '@mui/material';
import { PageContainer } from 'components/PageContainer';
import { CustomAccordion } from 'components/accordion';
import { useOptimizationJobs } from 'contexts/OptimizationJobsContext';
import { JobsTable } from './components/JobsTable';
import { DepotSummary } from './components/DepotSummary';
import { NoDataMessage } from 'components/NoDataMessage/styles';
import {
  MainContainer,
  LoadingContainer,
  AccordionTitleContainer,
  DepotTitle,
  PulsingDot,
} from './styles';

export const RouteOptimization = () => {
  const { jobs, loading, getAllJobs } = useOptimizationJobs();

  const allJobs = getAllJobs();
  const depotNames = Object.keys(jobs);

  const hasJobsInProgress = (depotJobs: any[]) => {
    return depotJobs.some(job => job.status === 'otimizando' || job.status === 'reordenando');
  };

  if (loading) {
    return (
      <div className="pageContent">
        <PageContainer>
          <MainContainer>
            <div className='infos'>
              <h3>Otimização de Rotas</h3>
            </div>
            <LoadingContainer>
              <CircularProgress size={40} />
              <Typography variant="body1" color="textSecondary">
                Carregando jobs de otimização...
              </Typography>
            </LoadingContainer>
          </MainContainer>
        </PageContainer>
      </div>
    );
  }

  return (
    <div className="pageContent">
      <PageContainer>
        <MainContainer>
        <div className='infos'>
          <h3>Otimização de Rotas</h3>
        </div>

          {allJobs.length > 0 ? (
            <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
              <CustomAccordion
                data={depotNames.map(depotName => ({
                  depotName,
                  jobs: jobs[depotName]
                }))}
                renderSummary={(depot) => (
                  <AccordionTitleContainer>
                    <DepotTitle>
                      <Typography
                        variant="h6"
                        sx={{
                          fontSize: { xs: '1rem', sm: '1.1rem', md: '1.2rem' },
                          fontWeight: 600,
                          color: 'rgba(0, 0, 0, 0.87)'
                        }}
                      >
                        {depot.depotName}
                      </Typography>
                      {hasJobsInProgress(depot.jobs) && (
                        <PulsingDot />
                      )}
                    </DepotTitle>
                    <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                      <DepotSummary jobs={depot.jobs} />
                    </Box>
                  </AccordionTitleContainer>
                )}
              >
                {(depot) => (
                  <>
                    <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                      <DepotSummary jobs={depot.jobs} isMobile />
                    </Box>
                    <JobsTable jobs={depot.jobs} />
                  </>
                )}
              </CustomAccordion>
            </Box>
          ) : (
            <NoDataMessage>
              <h3>Nenhum job encontrado</h3>
              <p>Não há jobs de otimização para o período selecionado.</p>
            </NoDataMessage>
          )}
        </MainContainer>
      </PageContainer>
    </div>
  );
};
